import { Link } from "gatsby";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import TopMenus from "./TopMenus";

const NAV_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "SiteNavigationElement",
  name: "Main Navigation",
  url: "https://www.prozo.com",
  hasPart: [
    {
      "@type": "SiteNavigationElement",
      name: "Solutions",
      url: "https://www.prozo.com/warehousing",
      description:
        "Warehousing, fulfilment, logistics, and value-added supply chain services across India.",
    },
    {
      "@type": "SiteNavigationElement",
      name: "Platform",
      url: "https://www.prozo.com/technology/order-management-system",
      description:
        "Integrated supply chain technology - OMS, WMS, TMS, Control Tower, and ProPilot AI.",
    },
    {
      "@type": "SiteNavigationElement",
      name: "Hyperlocal",
      url: "https://www.prozo.com/hyperlocal-delivery",
      description:
        "Dark store network and hyperlocal last-mile delivery across 745+ pin codes.",
    },
    {
      "@type": "SiteNavigationElement",
      name: "Company",
      url: "https://www.prozo.com/about-us/our-clients",
      description:
        "Clients, case studies, fulfilment network, and supply chain academy.",
      hasPart: [
        {
          "@type": "SiteNavigationElement",
          name: "Our Clients",
          url: "https://www.prozo.com/about-us/our-clients",
        },
        {
          "@type": "SiteNavigationElement",
          name: "Case Studies",
          url: "https://www.prozo.com/about-us/case-study",
        },
        {
          "@type": "SiteNavigationElement",
          name: "Fulfilment Network",
          url: "https://www.prozo.com/about-us/pfn",
        },
        {
          "@type": "SiteNavigationElement",
          name: "In the News",
          url: "https://www.prozo.com/media",
        },
      ],
    },
  ],
};

function Header({ hideMenu = false }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // check initial position
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(NAV_SCHEMA)}
        </script>
      </Helmet>

      {/* Top utility bar */}
      <div className="pz-nav__topbar">
        <div className="pz-nav__topbar-inner">
          <a href="tel:+919311847248" aria-label="Call Prozo">
            <i className="mdi mdi-phone" /> +91-9311847248
          </a>
          <span className="pz-nav__topbar-sep">|</span>
          <a href="mailto:sales@prozo.com" aria-label="Email Prozo">
            <i className="mdi mdi-email-outline" /> sales@prozo.com
          </a>
        </div>
      </div>

      {/* Main nav bar */}
      <header className={`pz-nav${scrolled ? " pz-nav--scrolled" : ""}`}>
        <div className="pz-nav__inner">
          <Link to="/" className="pz-nav__logo" aria-label="Prozo home">
            <img
              src="/media/Prozo-Logo.png"
              height={52}
              alt="Prozo - Supply Chain Operating System"
            />
          </Link>

          {!hideMenu && (
            <nav aria-label="Main navigation">
              <TopMenus />
            </nav>
          )}

          <div className="pz-nav__actions">
            <button
              type="button"
              className="pz-nav__cta"
              data-toggle="modal"
              data-target="#contact"
            >
              Say Hello <i className="mdi mdi-arrow-right" />
            </button>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
